var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7869 7.65658L12.4536 4.32324M15.7869 7.65658L11.6215 11.8219C11.0726 12.3708 10.4063 12.8042 9.64142 12.9361C8.86909 13.0693 7.91062 13.1137 7.45354 12.6566C6.99646 12.1995 7.0408 11.241 7.174 10.4687C7.30593 9.70374 7.7393 9.03749 8.28817 8.48858L12.4536 4.32324M15.7869 7.65658C15.7869 7.65658 18.2868 5.15658 16.6202 3.48991C14.9535 1.82324 12.4536 4.32324 12.4536 4.32324M17.0832 10.0003C17.0832 15.417 15.4165 17.0837 9.99984 17.0837C4.58317 17.0837 2.9165 15.417 2.9165 10.0003C2.9165 4.58366 4.58317 2.91699 9.99984 2.91699",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/EDIT.379fb0b79d5e35e6820e2a5379836588.svg";
export { ForwardRef as ReactComponent };